function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { TabWrapper } from './ApplicationStyle';
import ApplicationBody from './ApplicationBody';
import ToggleButton from '../Button/ToggleButton/ToggleButton';
import Card from '@material-ui/core/Card';
import RecommendationTable from './RecommendationTable/RecommendationTable';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import RecommendationBody from '../Filter/RecommendationBody';
import { setSearchString } from '../../slices/RiskFilterSlice';
import { useSelector, useDispatch } from 'react-redux';
import { pushShowApplyReco, pushShowApply, pushRestrictValue, pushConditionalTab } from '../../slices/ButtonsSlice';
import { pushShowCard } from '../../slices/RiskFilterSlice';
import { pushAccountWiseHeatMap } from '../../slices/ApplicationDrillHeatMapSlice';
import { deleteChipArrayAddCriteria, pushSelectedChipArray, pushClearFilterArray, pushChipArrayAddCriteria, pushApplyEvent } from '../../slices/RiskFilterSlice';
import { pushOverallHeatMap } from '../../slices/HeatMapSlice';
import RecommendationFilter from '../Button/FilterButton/RecommendationFilter';
import { pushRecoFilterWatch } from '../../slices/RiskFilterSlice';
import { pushTableData, pushRiskTableData } from '../../slices/recommendationTableSlice';

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: `scrollable-auto-tabpanel-${index}`,
    "aria-labelledby": `scrollable-auto-tab-${index}`
  }, other), value === index && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.type
  }, children)));
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  };
}

const StyledTabs = withStyles({
  root: {
    borderBottom: '1px solid #E0E0E0'
  },
  indicator: {
    backgroundColor: '#1A98F8',
    height: '4px'
  },
  flexContainer: {
    borderBottom: '4px solid #F0F5FA'
  }
})(props => /*#__PURE__*/React.createElement(Tabs, _extends({}, props, {
  TabIndicatorProps: {
    children: /*#__PURE__*/React.createElement("span", null)
  }
})));
const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: '#313131',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '13px',
    fontFamily: 'OpenSans-Regular',
    marginRight: theme.spacing(1),
    minWidth: '0px',
    opacity: 1,
    '&:focus': {
      opacity: 1,
      fontWeight: 500
    }
  },
  selected: {
    color: '#1A98F8'
  }
}))(props => /*#__PURE__*/React.createElement(Tab, _extends({
  disableRipple: true
}, props)));
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  panel: {
    padding: '16px 0px'
  },
  type: {
    position: 'unset !important'
  }
}));
export default function ApplicationHeader({
  heatMap,
  history,
  riskTableData,
  tableData,
  clickHandler,
  setRowsPerPage,
  setPage,
  nextTableData,
  rowsPerPage,
  handleRequestSort,
  watch,
  setWatch,
  setRiskTablePage,
  setRiskTableRowsRowsPerPage,
  handleSetriskTableSortString,
  riskTableRowsPerPage,
  recomandationLoading,
  handlesetLoading,
  riskLoading,
  handleriskLoading,
  risknextTableData,
  order,
  orderBy,
  riskColumOrder,
  riskColumOderBy,
  handleTableRowClick,
  isTreemapApplication,
  pageType
}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const [recoFilterWatch, setRecoFilterWatch] = React.useState(0);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  let originRiskTableData = [];
  let originTableData = [];
  let accountRiskTableData = [];
  let accountTableData = [];
  const apiResponseData = useSelector(state => state.recommendationTable.dashboardResponse);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const drillApiResponseData = useSelector(state => state.recommendationTable.ApplicationResponse);
  const accountWiseApiResponseData = useSelector(state => state.recommendationTable.applicationDrillHeatmap);

  if (apiResponseData && apiResponseData?.data?.responseList.length) {
    originTableData = apiResponseData.data.responseList;
  }

  if (riskApiResponseData && riskApiResponseData?.data?.responseList.length) {
    originRiskTableData = riskApiResponseData.data.responseList;
  }

  if (drillApiResponseData && drillApiResponseData?.data?.responseList.length) {
    accountTableData = drillApiResponseData.data.responseList;
  }

  if (accountWiseApiResponseData && accountWiseApiResponseData?.data?.responseList.length) {
    accountRiskTableData = accountWiseApiResponseData.data.responseList;
  }

  const filterRecoMandationData = useSelector(state => state.recommendationTable.recoOriginFilter);
  const recomandationData = applyEvent ? filterRecoMandationData?.data : nextTableData?.data;
  let totalElements = recomandationData ? recomandationData?.totalElements : 0;
  const originRiskFilterResponse = useSelector(state => state.recommendationTable.originFilter);
  const accountRiskFilterResponse = useSelector(state => state.recommendationTable.accountFilter);
  const riskData = clickEvent ? applyEvent ? accountRiskFilterResponse?.data : risknextTableData?.data : applyEvent ? originRiskFilterResponse?.data : risknextTableData?.data;
  let riskTotalElements = riskData ? riskData?.totalElements : 0;

  const handleRecoFilterWatch = statusValue => {
    if (applyEvent) {
      let watchStatusValue = statusValue;
      dispatch(pushRecoFilterWatch(watchStatusValue));
      setRecoFilterWatch(statusValue);
      setWatch(statusValue);
      dispatch(pushTableData([]));
    } else {
      dispatch(pushTableData([]));
      setWatch(statusValue);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);

    if (newValue === 1) {
      dispatch(pushConditionalTab(false));
    } else {
      dispatch(pushConditionalTab(true));
    }

    dispatch(pushShowApplyReco(false));
    dispatch(pushShowApply(false));
    dispatch(pushRestrictValue(false));
    dispatch(pushShowCard(false));
    dispatch(pushShowApply(false));

    if (!clickEvent) {
      dispatch(pushTableData(originTableData));
      dispatch(pushRiskTableData(originRiskTableData));
      dispatch(pushOverallHeatMap(originRiskTableData));
    } else {
      dispatch(pushTableData(accountTableData));
      dispatch(pushRiskTableData(accountRiskTableData));
      dispatch(pushAccountWiseHeatMap(accountRiskTableData));
    }

    dispatch(deleteChipArrayAddCriteria([]));
    dispatch(pushSelectedChipArray([]));
    dispatch(pushClearFilterArray([]));
    dispatch(pushChipArrayAddCriteria([]));
    dispatch(pushApplyEvent(false));
    dispatch(setSearchString(''));
  };

  const showApplyReco = useSelector(state => state.buttonSlice.showApplyReco);
  const showCard = useSelector(state => state.riskFilterSlice.showCard);
  const recoExportApi = useSelector(state => state.apiUrl.recoApi);
  const recoExportFilterApi = useSelector(state => state.apiUrl.filterRecoApi);
  const generalComponent = /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "static",
    color: "default",
    elevation: 0
  }, /*#__PURE__*/React.createElement(TabWrapper, null, /*#__PURE__*/React.createElement(Card, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(StyledTabs, {
    value: value,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(StyledTab, _extends({
    label: "Risk"
  }, a11yProps(0))), /*#__PURE__*/React.createElement(StyledTab, _extends({
    label: "Recommendations"
  }, a11yProps(1)))), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 0,
    classes: {
      root: classes.tab
    }
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    heatMap: heatMap,
    elevation: 0,
    risknextTableData: risknextTableData,
    totalCount: riskTotalElements
  }), /*#__PURE__*/React.createElement(ApplicationBody, {
    heatMap: heatMap,
    clickHandler: clickHandler,
    history: history,
    riskTableData: riskTableData,
    setRiskTablePage: setRiskTablePage,
    setRiskTableRowsRowsPerPage: setRiskTableRowsRowsPerPage,
    handleSetriskTableSortString: handleSetriskTableSortString,
    riskTableRowsPerPage: riskTableRowsPerPage,
    riskLoading: riskLoading,
    handleriskLoading: handleriskLoading,
    risknextTableData: risknextTableData,
    riskColumOrder: riskColumOrder,
    riskColumOderBy: riskColumOderBy,
    handleTableRowClick: handleTableRowClick,
    isTreemapApplication: isTreemapApplication,
    pageType: pageType
  })), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 1
  }, !showApplyReco && !showCard ? /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(RecommendationFilter, {
    setWatch: handleRecoFilterWatch,
    handlesetLoading: handlesetLoading,
    recomandationLoading: recomandationLoading,
    watch: watch,
    totalCount: totalElements,
    nextTableData: nextTableData,
    exportApi: applyEvent ? recoExportFilterApi : recoExportApi,
    pageType: pageType
  }), /*#__PURE__*/React.createElement(RecommendationTable, {
    history: history,
    tableData: tableData,
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    watch: applyEvent ? recoFilterWatch : watch,
    setWatch: handleRecoFilterWatch,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    order: order,
    orderBy: orderBy,
    pageType: pageType
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationFilter, {
    setWatch: setWatch,
    handlesetLoading: handlesetLoading,
    recomandationLoading: recomandationLoading,
    watch: watch
  }), /*#__PURE__*/React.createElement(RecommendationBody, {
    watch: watch
  })))))));
  const environmentComponent = !showApplyReco && !showCard ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationFilter, {
    setWatch: handleRecoFilterWatch,
    handlesetLoading: handlesetLoading,
    recomandationLoading: recomandationLoading,
    watch: watch,
    totalCount: totalElements,
    exportApi: applyEvent ? recoExportFilterApi : recoExportApi,
    pageType: pageType
  }), /*#__PURE__*/React.createElement(RecommendationTable, {
    history: history,
    tableData: tableData,
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    watch: applyEvent ? recoFilterWatch : watch,
    setWatch: handleRecoFilterWatch,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    order: order,
    orderBy: orderBy,
    pageType: pageType
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationFilter, {
    setWatch: setWatch,
    handlesetLoading: handlesetLoading,
    recomandationLoading: recomandationLoading,
    watch: watch
  }), /*#__PURE__*/React.createElement(RecommendationBody, null));
  return riskTableData ? generalComponent : environmentComponent;
}